exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".compact.card-header{background-color:#f5f5f5}.compact.card-header-title{padding-top:1px;padding-bottom:1px}.compact.card-content{padding:.75rem 1.5rem}.compact.card-footer-item{padding-top:0;padding-bottom:0}.is-info.card-footer-item{background-color:#209cee;color:#fff}.is-danger.card-footer-item{background-color:#ff3860;color:#fff}.has-black.card-footer-item{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader!./src/components/ProductCard.Vue?vue&type=style&index=0&lang=css
// module id = 190
// module chunks = 0